export function IsMobile() {
  const isMobile =
    /Android|webOS|Mobile|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // ipad > ios 13

  return isMobile;
  // return true; // TODO: change this, override for now for switzerland
}

export function IsSafari() {
  const ua = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  return isSafari;
}

export function BrowserInfo() {
  const ua = navigator.userAgent;
  return {
    isSafari: IsSafari(),
    isMobile: IsMobile(),
    isChrome: /chrome/i.test(ua) && !/edge/i.test(ua),
    isFirefox: /firefox/i.test(ua),
    isEdge: /edge/i.test(ua),
    userAgent: ua,
  };
}
